import React from 'react'
import { buildPropTypes, pt } from 'common-data/proptypehelpers'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import _ from 'common-tools/LodashHelper'
import { componentGetCompareProps } from 'common-tools/index'
import { FAIcon } from './FAIcon'
import styles from './WizardBox.less'

export const WizardBoxSteps = {
  Done: 'done',
  Cancel: 'cancel'
}

export class WizardBoxItem extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    children: pt.any,
    stepId: pt.string.isRequired,
    nextStepId: pt.string.isRequired,
    previousStepId: pt.string,
    icon: pt.string.isRequired
  })

  static defaultProps = {
    icon: 'building'
  }

  render () {
    const { children } = this.props
    return children
  }
}

export class WizardBox extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      activeStep: undefined,
      visitedSteps: [],
      changingSteps: false
    }
  }

  static propTypes = buildPropTypes([

  ], {
    children: pt.oneOfType([pt.arrayOf(pt.element), pt.element]),
    stepMap: pt.arrayOf(pt.shape({
      previousId: pt.string,
      currentId: pt.string,
      nextId: pt.string
    })),
    activeStepId: pt.string
  })

  static defaultProps = {
    stepMap: []
  }

  componentDidUpdate (prevProps, prevState) {
    let activeStepId = componentGetCompareProps('activeStepId', this.props, prevProps, '')

    if (activeStepId.HasChanged) {
      const { visitedSteps } = this.state
      this.setState({
        visitedSteps: _.concat(visitedSteps, [activeStepId.Current])
      }, () => {
        this.toggle(activeStepId.Current, true)
      })
    }
  }

  async toggle (stepId, resetActiveStep = false) {
    const { beforeStepAction, afterStepAction, stepMap } = this.props
    const { visitedSteps, activeStep } = this.state

    this.setState({
      changingSteps: true
    })

    if (activeStep !== stepId) {
      let stepIdList = _.map(stepMap, (sm) => { return sm.currentId })
      stepIdList.unshift(WizardBoxSteps.Cancel)
      stepIdList.push(WizardBoxSteps.Done)

      let currentStepPos = _.indexOf(stepIdList, activeStep)
      let nextStepIdPos = _.indexOf(stepIdList, stepId)

      let toggleDirection = 'none'

      if (currentStepPos < nextStepIdPos) {
        toggleDirection = 'forward'
      } else if (currentStepPos > nextStepIdPos) {
        toggleDirection = 'backward'
      }

      if (_.isFunction(beforeStepAction)) {
        if (await beforeStepAction(stepId, resetActiveStep ? undefined : activeStep, toggleDirection)) {
          this.setState({
            changingSteps: false
          })
          return // abort step
        }
      }
      if (stepId !== WizardBoxSteps.Cancel) {
        this.setState({
          activeStep: stepId,
          visitedSteps: _.concat(visitedSteps, stepId)
        }, async () => {
          if (_.isFunction(afterStepAction)) {
            await afterStepAction(stepId, resetActiveStep ? undefined : activeStep, toggleDirection)
          }
        })
      }
    }

    this.setState({
      changingSteps: false
    })
  }

  getItems (stepMap, children, loading) {
    const ret = {
      navs: [],
      steps: []
    }

    const { activeStep, visitedSteps } = this.state

    for (let currentStepMap of stepMap) {
      let currentId = currentStepMap.currentId
      let matchChild = _.find(children, (i) => { return i.props.stepId === currentId }) || { props: {
        icon: 'question',
        children: undefined
      } }

      ret.navs.push(<NavItem key={currentId}>
        <NavLink
          className={activeStep === currentId ? 'active' : _.indexOf(visitedSteps, currentId) > -1 ? 'completed' : ''}
          onClick={loading === true ? undefined : _.indexOf(visitedSteps, currentId) > -1 ? () => { this.toggle(currentId) } : null}
        >
          <span className="round-tab">
            <FAIcon size='35px' name={matchChild.props.icon || 'question'} />
          </span>
        </NavLink>
      </NavItem>)
      ret.steps.push(<TabPane key={currentId} tabid={currentId}>
        {activeStep === currentId
          ? _.isFunction(matchChild.props.children)
            ? matchChild.props.children({
              firstVisit: _.indexOf(visitedSteps, currentStepMap.nextId) === -1,
              nextId: currentStepMap.nextId,
              previousId: currentStepMap.previousId,
              visitedSteps: visitedSteps || []
            })
            : matchChild.props.children
          : null
        }
      </TabPane>)
    }

    ret.navs.unshift(<NavItem key={WizardBoxSteps.Cancel}>
      <NavLink
        className='exit'
        onClick={() => { this.toggle(WizardBoxSteps.Cancel) }}
      >
        <span className="round-tab">
          <FAIcon size='25px' name={'times'} />
        </span>
      </NavLink>
    </NavItem>)

    return ret
  }

  renderStepAction (action, loading) {
    const { hideNextStepButton, stepMap } = this.props
    const { activeStep } = this.state

    const matchStep = _.find(stepMap, { currentId: activeStep })

    if (!matchStep) {
      return null
    }

    switch (action) {
      case 'next':

        let nextId = matchStep.nextId
        let nextIdClick = loading === true ? undefined : () => { this.toggle(nextId) }

        if (nextId === WizardBoxSteps.Done) {
          return <div className={styles.actionNavRight} onClick={nextIdClick}>
            {loading === true
              ? <FAIcon size='35px' name='spinner' spin />
              : <FAIcon size='35px' name='check' />
            }
          </div>
        } else {
          if (nextId) {
            if (hideNextStepButton === true) {
              return <div className={styles.actionNavRight}>
                <FAIcon size='35px' name='times' toolTip='Thou shalt not pass!' />
              </div>
            } else {
              return <div className={styles.actionNavRight} onClick={nextIdClick}>
                <FAIcon size='35px' name='chevron-right' />
              </div>
            }
          }
          break
        }
      case 'previous':

        let previousId = matchStep.previousId
        let previousIdClick = loading === true ? undefined : () => { this.toggle(previousId) }

        if (previousId) {
          return <div className={styles.actionNavLeft} onClick={previousIdClick}>
            <FAIcon name='chevron-left' size='35px' />
          </div>
        }
        break
      default:
        return null
    }
  }

  render () {
    const { children, style = {}, stepMap, loading = false } = this.props
    const { changingSteps } = this.state

    const processing = loading || changingSteps
    const items = this.getItems(stepMap, children, processing)

    return (
      <div className={styles.root} style={style}>
        <div className={styles.header}>
          <div className="connecting-line"></div>
          <Nav tabs>
            {items.navs}
          </Nav>
        </div>
        <div className={styles.body}>
          <TabContent activeTab={this.state.activeStep}>
            {items.steps}
          </TabContent>
        </div>
        {this.renderStepAction('previous', processing)}
        {this.renderStepAction('next', processing)}
      </div>
    )
  }
}
